import { ThunkAction } from 'redux-thunk';
import store, { RootState } from 'store';
import ApiClient, { createMultipartTokenConfig } from 'api/ApiClient';
import { AxiosResponse } from 'axios';
import {
    PHONESEARCH_ERROR_ACTION_TYPE,
    PHONESEARCH_START_ACTION_TYPE,
    PHONESEARCH_SUCCESS_ACTION_TYPE,
    PhoneSearchAction
} from './phoneSearchActionsTypes';
import { PhoneSearchDto } from './phoneSearchDtos';
import { PhoneSearchResult } from 'model/PhoneSearch';
import { convertResults } from './phoneSearchConverter';

const searchStart = (): PhoneSearchAction => {
    return {
        type: PHONESEARCH_START_ACTION_TYPE
    };
};

export const phoneSearchSuccess = (results: Array<PhoneSearchResult>): PhoneSearchAction => ({
    type: PHONESEARCH_SUCCESS_ACTION_TYPE,
    payload: { results }
});

export const phoneSearchError = (error: string): PhoneSearchAction => ({
    type: PHONESEARCH_ERROR_ACTION_TYPE,
    payload: { error }
});

export const phoneSearchThunk = (searchText: string): ThunkAction<void, RootState, unknown, any> => {
    return async dispatch => {
        dispatch(searchStart());
        const marketplaceId = store.getState().login.auth.marketplaceId;
        try {
            const url = `/phone_searches?marketplace_id=${marketplaceId}&value=${searchText}`;
            const response: AxiosResponse<Array<PhoneSearchDto>> = await ApiClient.get(
                url,
                createMultipartTokenConfig(store.getState().login.auth.token!)
            );
            dispatch(phoneSearchSuccess(convertResults(response.data)));
        } catch (error) {
            dispatch(phoneSearchError('Error searching phones'));
        }
    };
};
